import { render, staticRenderFns } from "./YouIDWebcam.vue?vue&type=template&id=40953b35"
import script from "./YouIDWebcam.vue?vue&type=script&lang=ts"
export * from "./YouIDWebcam.vue?vue&type=script&lang=ts"
import style0 from "./YouIDWebcam.vue?vue&type=style&index=0&id=40953b35&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports